import { INewsSource } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_INFO } from 'common/toast';
import React, { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import HighlightText from './HighlightText';
import { SECTION_KEYWORD } from 'helpers/constans';
import { formatNumberWithCommas, formatToJson } from 'helpers/format';
import JSONPretty from 'react-json-pretty';

interface BoxSourceNewsProps {
    keyword?: string,
    keyword_sub?: string,
    item: INewsSource | null;
    index: number,
    isSubKeywordFrequency?: boolean,
    session?: number | string
}

const BoxSourceNews: React.FC<BoxSourceNewsProps> = ({ item, index, keyword, keyword_sub, session = '000', isSubKeywordFrequency = true }) => {
    const { t } = useTranslation();
    const copyTextToClipboard = useCallback(async (text: string) => {
        if ('clipboard' in navigator) {
            await navigator.clipboard.writeText(text);
        } else {
            document.execCommand('copy', true, text);
        }
        toast(`${t('Copied to the clipboard.')}`, CONFIG_OPTION_TOAST_INFO);
    }, []);
    return (
        <>
            {!([String(SECTION_KEYWORD.CONTENT_APPTECH), String(SECTION_KEYWORD.CONTENT_GOLD_PRICE),
            String(SECTION_KEYWORD.CONTENT_VOTE), String(SECTION_KEYWORD.BOOSTING_V2),
            String(SECTION_KEYWORD.TRAVEL_NEWS), String(SECTION_KEYWORD.WEATHER_NEWS),
            String(SECTION_KEYWORD.WEATHER_WARNING), String(SECTION_KEYWORD.STOCK_NEWS),
            String(SECTION_KEYWORD.GOVERNMENT_IMAGE_BASED_NEWS),
            String(SECTION_KEYWORD.GOVERNMENT_LOGO_BASED_NEWS)]?.includes(String(session))) && <Fragment>
                    <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                        {!!item?.title && <span className="text-success d-flex align-items-center cursor-pointer me-3" onClick={() => copyTextToClipboard(`${item?.title || ''}\n\n${item?.body}`)}><i className="ri ri-file-copy-line" style={{ transform: 'translateY(1px)' }} /> {t('Copy')}</span>}
                        {!!item?.title && <Link
                            className="nav-link cursor-pointer hover-underline-primary me-3"
                            target="_blank"
                            to={item?.url}
                        >
                            <i className="ri ri-links-line" style={{ transform: 'translateY(-1px)' }} />{t('Source Link')}
                        </Link>}
                        {t('Source News')} {index + 1}
                    </span>
                    <div className="p-2 px-0">
                        <div className="d-flex flex-wrap align-items-start gap-2 mt-2 pt-2 mb-1" style={{ borderBottom: '1px dashed #d0caca', paddingBottom: '4px' }}>
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 fs-14 fs-md-16">
                                    {t('Main Keyword Frequency')}:
                                </div>
                                <div className="flex-grow-1 fs-14 fs-md-16 ms-1">
                                    <span className="fw-medium">{Number(item?.title_count || 0) + Number(item?.body_count || 0)}</span>
                                </div>
                            </div>
                            {isSubKeywordFrequency && <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 fs-14 fs-md-16">
                                    {t('Sub Keyword Frequency')}:
                                </div>
                                <div className="flex-grow-1 fs-14 fs-md-16 ms-1">
                                    <span className="fw-medium">{Number(item?.title_keyword_sub_count || 0) + Number(item?.body_keyword_sub_count || 0)}</span>
                                </div>
                            </div>
                            }
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 fs-14 fs-md-16">
                                    {t('Date')}:
                                </div>
                                <div className="flex-grow-1 fs-14 fs-md-16 ms-1">
                                    <span className="fw-medium">{item?.publish_time || ''}</span>
                                </div>
                            </div>
                        </div>
                        <p className="mb-3 fs-20 fs-md-18" style={{ lineHeight: '170%', fontWeight: 600 }}>
                            <HighlightText text={item?.title || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                        </p>
                        <p className="mb-3 mt-3 fs-17 fs-md-16 box-image-max-w-100" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                            <HighlightText text={item?.body_html || item?.body || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                        </p>
                    </div>
                </Fragment>}
            {!!(String(session) === String(SECTION_KEYWORD.CONTENT_APPTECH)) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.url && <Link
                        className="nav-link cursor-pointer hover-underline-primary me-3"
                        target="_blank"
                        to={item?.url}
                    >
                        <i className="ri ri-links-line" style={{ transform: 'translateY(-1px)' }} />{t('Source Link')}
                    </Link>}
                    {t('Source')} {index + 1}
                </span>
                <div className="p-2 px-0">
                    <div className="d-flex flex-wrap align-items-end gap-2 mt-2 pt-2 mb-1" style={{ borderBottom: '1px dashed #d0caca', paddingBottom: '4px' }}>
                        <div className="d-flex text-end align-items-end  justify-content-end w-100">
                            <div className="flex-shrink-0 fs-14 fs-md-16">
                                {t('Collected at')}:
                            </div>
                            <div className="fs-14 fs-md-16 ms-1">
                                <span className="fw-medium">{item?.collect_at || ''}</span>
                            </div>
                        </div>
                    </div>
                    <p className="mb-0 mt-3 fs-17 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <span className="mb-0 mt-3 fs-17 fs-md-16">{t('Question')}:</span> <HighlightText text={item?.question || ''} keyword={''} /> <br />
                    </p>
                    <p className="mb-0 fs-20 fs-md-18" style={{ whiteSpace: 'pre-line', lineHeight: '170%', fontWeight: 600 }}>
                        <span className="mb-0 mt-3 fs-17 fs-md-16" style={{ fontWeight: 'normal' }}>{t('Answer')}:</span>  <HighlightText text={item?.answer || ''} opacity_bg={0.7} keyword={''} />
                    </p>
                    <p className="mb-3 fs-20 fs-md-18" style={{ whiteSpace: 'pre-line', lineHeight: '170%', fontWeight: 'normal' }}>
                        <span className="mb-0 mt-3 fs-17 fs-md-16" style={{ fontWeight: 'normal' }}>{t('Content Paragraph')}:</span>  <HighlightText text={item?.content_paragraph || ''} opacity_bg={0.7} keyword={''} />
                    </p>
                </div>
            </Fragment>}
            {!!(String(session) === String(SECTION_KEYWORD.CONTENT_GOLD_PRICE)) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.url && <Link
                        className="nav-link cursor-pointer hover-underline-primary me-3"
                        target="_blank"
                        to={item?.url}
                    >
                        <i className="ri ri-links-line" style={{ transform: 'translateY(-1px)' }} />{t('Source Link')}
                    </Link>}
                    {t('Source')} {index + 1}
                </span>
                <div className="p-2 px-0">
                    <div className="d-flex flex-wrap align-items-end gap-2 mt-2 pt-2 mb-1" style={{ borderBottom: '1px dashed #d0caca', paddingBottom: '4px' }}>

                    </div>
                    <div className="px-0" style={{ minHeight: '80dvh' }}>
                        <div className="mb-3 mt-3 fs-17 fs-md-16" style={{ whiteSpace: 'break-spaces' }} dangerouslySetInnerHTML={{ __html: item?.json_data || '' }}></div>
                    </div>
                </div>
            </Fragment>}
            {!!(String(session) === String(SECTION_KEYWORD.CONTENT_VOTE)) && <Fragment>

                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.url && <Link
                        className="nav-link cursor-pointer hover-underline-primary me-3"
                        target="_blank"
                        to={item?.url}
                    >
                        <i className="ri ri-links-line" style={{ transform: 'translateY(-1px)' }} />{t('Source')}
                    </Link>}
                    {t('Source')} {index + 1}
                </span>
                <div className="p-2 px-0">
                    <div className="d-flex flex-wrap align-items-end gap-2 mt-2 pt-2 mb-1" style={{ borderBottom: '1px dashed #d0caca', paddingBottom: '4px' }}>

                    </div>
                    <div className="px-0" style={{ minHeight: '80dvh' }}>
                        <iframe
                            src={item?.url || 'https://dctrend.ai/vote'}
                            width="100%"
                            height="700px"
                            title="Source Preview"
                        ></iframe>
                    </div>
                </div>
            </Fragment>}
            {!!(String(session) === String(SECTION_KEYWORD.BOOSTING_V2)) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.url && <Link
                        className="nav-link cursor-pointer hover-underline-primary me-3"
                        target="_blank"
                        to={item?.url}
                    >
                        <i className="ri ri-links-line" style={{ transform: 'translateY(-1px)' }} />{t('Source')}
                    </Link>}
                    {t('Source')} {index + 1}
                </span>
                <div className="p-2 px-0">
                    <div className="d-flex flex-wrap align-items-end gap-2 mt-2 pt-2 mb-1" style={{ borderBottom: '1px dashed #d0caca', paddingBottom: '4px' }}>

                    </div>
                    <div className="px-0" style={{ minHeight: '80dvh' }}>
                        <iframe
                            src={item?.url || ''}
                            width="100%"
                            height="700px"
                            title="Source Preview"
                        ></iframe>
                    </div>
                </div>
            </Fragment>}
            {([String(SECTION_KEYWORD.TRAVEL_NEWS)]?.includes(String(session))) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.name && <span className="text-success d-flex align-items-center cursor-pointer me-3" onClick={() => copyTextToClipboard(`${item?.name || ''}\n\n${item?.address}\n\n${item?.introduction}`)}><i className="ri ri-file-copy-line" style={{ transform: 'translateY(1px)' }} /> {t('Copy')}</span>}
                    {t('Source')} {index + 1}
                </span>
                <div className="p-2 px-0">
                    <p className="mb-2 mt-3 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <span style={{ backgroundColor: "rgb(183, 234, 255)" }} className="text-muted">{t('Place Name')}:</span> <HighlightText text={item?.name || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                    </p>
                    <p className="mb-2 mt-0 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <span style={{ backgroundColor: "rgb(183, 234, 255)" }} className="text-muted">{t('Address')}:</span> <HighlightText text={item?.address || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                    </p>
                    <p className="mb-2 mt-0 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <span style={{ backgroundColor: "rgb(183, 234, 255)" }} className="text-muted">{t('Number of Reviews')}:</span> {formatNumberWithCommas(Number(item?.total_blog_reviews_count) + Number(item?.total_visitor_reviews_count))}
                    </p>
                    <p className="mb-2 mt-0 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <span style={{ backgroundColor: "rgb(183, 234, 255)" }} className="text-muted">{t('Description(naver)')}:</span> <HighlightText text={item?.introduction || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                    </p>
                    <p className="mb-3 mt-0 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <span style={{ backgroundColor: "rgb(183, 234, 255)" }} className="text-muted">{t('Description(visitkorea)')}:</span> <HighlightText text={item?.description || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                    </p>
                </div>
            </Fragment>}

            {([String(SECTION_KEYWORD.WEATHER_NEWS), String(SECTION_KEYWORD.WEATHER_WARNING)]?.includes(String(session))) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.name && <span className="text-success d-flex align-items-center cursor-pointer me-3" onClick={() => copyTextToClipboard(`${item?.weather_info_list || ''}`)}><i className="ri ri-file-copy-line" style={{ transform: 'translateY(1px)' }} /> {t('Copy')}</span>}
                </span>
                <div className="p-2 px-0">
                    <p className="mb-2 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <HighlightText text={item?.prompt || ''} keyword={keyword || ''} sub_keyword={keyword_sub} is_highlight_date={true} />
                    </p>
                </div>
            </Fragment>}

            {([String(SECTION_KEYWORD.STOCK_NEWS)]?.includes(String(session))) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.info_str && <span className="text-success d-flex align-items-center cursor-pointer me-3" onClick={() => copyTextToClipboard(`${item?.info_str || ''}`)}><i className="ri ri-file-copy-line" style={{ transform: 'translateY(1px)' }} /> {t('Copy')}</span>}
                </span>
                <div className="p-2 px-0">
                    <p className="mb-3 mt-0 fs-15 fs-md-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                        <HighlightText text={item?.info_str || ''} keyword={keyword || ''} sub_keyword={keyword_sub} />
                    </p>
                </div>
            </Fragment>}

            {([String(SECTION_KEYWORD.GOVERNMENT_IMAGE_BASED_NEWS), String(SECTION_KEYWORD.GOVERNMENT_LOGO_BASED_NEWS)]?.includes(String(session))) && <Fragment>
                <span className="d-flex align-items-center text-primary position-absolute fs-13" style={{ top: 5, right: 10 }}>
                    {!!item?.original_url && <Link
                        className="nav-link cursor-pointer hover-underline-primary me-3"
                        target="_blank"
                        to={item?.original_url}
                    >
                        <i className="ri ri-links-line" style={{ transform: 'translateY(-1px)' }} />{t('Source Link')}
                    </Link>}
                </span>
                <div className="p-2 px-0">
                    <div className="d-flex flex-wrap align-items-end gap-2 mt-2 pt-2 mb-1" style={{ borderBottom: '1px dashed #d0caca', paddingBottom: '4px' }}>
                    </div>
                    <div className="px-0" style={{ minHeight: '80dvh' }}>
                        <iframe
                            src={item?.original_url || ''}
                            width="100%"
                            height="700px"
                            title="Source Preview"
                        ></iframe>
                    </div>
                </div>
            </Fragment>}
        </>
    );
};

export default React.memo(BoxSourceNews);
